
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Card from '../../components/base/Card';

interface Prize {
  rank: string;
  name: string;
  value: string;
  count: number;
  icon: string;
  color: string;
}

export default function Prizes() {
  const prizes: Prize[] = [
    { rank: '1', name: 'Togg Araba', value: '1.440.000 TL Değerinde, 1 Adet', count: 1, icon: 'ri-car-line', color: 'from-yellow-400 to-yellow-500' },
    { rank: '2', name: '700.000 TL Girişimcilik Nakit Desteği', value: '1 Adet', count: 1, icon: 'ri-money-dollar-circle-line', color: 'from-green-400 to-green-500' },
    { rank: '3', name: '350.000 TL Girişimcilik Nakit Desteği', value: '1 Adet', count: 1, icon: 'ri-money-dollar-circle-line', color: 'from-emerald-400 to-emerald-500' },
    { rank: '4', name: '150.000 TL Girişimcilik Nakit Desteği', value: '1 Adet', count: 1, icon: 'ri-money-dollar-circle-line', color: 'from-teal-400 to-teal-500' },
    { rank: '5-6', name: '100.000 TL Girişimcilik Nakit Desteği', value: '2 Adet', count: 2, icon: 'ri-money-dollar-circle-line', color: 'from-cyan-400 to-cyan-500' },
    { rank: '7-8', name: '75.000 TL Girişimcilik Nakit Desteği', value: '2 Adet', count: 2, icon: 'ri-money-dollar-circle-line', color: 'from-lime-400 to-lime-500' },
    { rank: '9-10', name: 'Akıllı Telefon S24 Ultra', value: '2 Adet', count: 2, icon: 'ri-smartphone-line', color: 'from-pink-400 to-pink-500' },
    { rank: '11-12', name: '50.000 TL Girişimcilik Nakit Desteği', value: '2 Adet', count: 2, icon: 'ri-money-dollar-circle-line', color: 'from-amber-400 to-amber-500' },
    { rank: '13-15', name: 'Elektrikli Motosiklet', value: '3 Adet', count: 3, icon: 'ri-motorbike-line', color: 'from-orange-400 to-orange-500' },
    { rank: '16-18', name: 'Tatil Çeki 30.000 TL Değerinde', value: '3 Adet', count: 3, icon: 'ri-flight-takeoff-line', color: 'from-sky-400 to-sky-500' },
    { rank: '19-21', name: 'Dizüstü Bilgisayar', value: '3 Adet', count: 3, icon: 'ri-macbook-line', color: 'from-gray-400 to-gray-500' },
    { rank: '22-24', name: 'PlayStation 5', value: '3 Adet', count: 3, icon: 'ri-gamepad-line', color: 'from-blue-600 to-blue-700' },
    { rank: '25-28', name: 'Tam Altın', value: '4 Adet', count: 4, icon: 'ri-coin-line', color: 'from-yellow-500 to-yellow-600' },
    { rank: '29-32', name: '25.000 TL Girişimcilik Nakit Desteği', value: '4 Adet', count: 4, icon: 'ri-money-dollar-circle-line', color: 'from-green-500 to-green-600' },
    { rank: '33-36', name: 'Elektrikli Scooter', value: '4 Adet', count: 4, icon: 'ri-riding-line', color: 'from-indigo-400 to-indigo-500' },
    { rank: '37-40', name: 'Yarım Altın', value: '4 Adet', count: 4, icon: 'ri-coin-line', color: 'from-yellow-600 to-yellow-700' },
    { rank: '41-45', name: '10.000 TL Girişimcilik Nakit Desteği', value: '5 Adet', count: 5, icon: 'ri-money-dollar-circle-line', color: 'from-emerald-500 to-emerald-600' },
    { rank: '46-50', name: 'Bisiklet', value: '5 Adet', count: 5, icon: 'ri-bike-line', color: 'from-green-600 to-green-700' },
    { rank: '51-55', name: 'Çeyrek Altın', value: '5 Adet', count: 5, icon: 'ri-coin-line', color: 'from-yellow-700 to-amber-600' },
    { rank: '56-60', name: '5.000 TL Girişimcilik Nakit Desteği', value: '5 Adet', count: 5, icon: 'ri-money-dollar-circle-line', color: 'from-teal-500 to-teal-600' },
    { rank: '61-70', name: 'Tablet', value: '10 Adet', count: 10, icon: 'ri-tablet-line', color: 'from-purple-400 to-purple-500' },
    { rank: '71-80', name: 'Akıllı Saat', value: '10 Adet', count: 10, icon: 'ri-time-line', color: 'from-rose-400 to-rose-500' },
    { rank: '81-90', name: 'Bluetooth Kulaklık', value: '10 Adet', count: 10, icon: 'ri-headphone-line', color: 'from-slate-400 to-slate-500' },
    { rank: '91-100', name: 'VR Gözlük', value: '10 Adet', count: 10, icon: 'ri-glasses-line', color: 'from-fuchsia-400 to-fuchsia-500' },
    { rank: '101-150', name: '2.000 TL Girişimcilik Nakit Desteği', value: '50 Adet', count: 50, icon: 'ri-money-dollar-circle-line', color: 'from-cyan-500 to-cyan-600' },
    { rank: '151-250', name: '1.000 TL Girişimcilik Nakit Desteği', value: '100 Adet', count: 100, icon: 'ri-money-dollar-circle-line', color: 'from-lime-500 to-lime-600' },
    { rank: '251-400', name: 'Futbol Topu', value: '150 Adet', count: 150, icon: 'ri-football-line', color: 'from-green-700 to-green-800' },
    { rank: '401-550', name: 'Basketbol Topu', value: '150 Adet', count: 150, icon: 'ri-basketball-line', color: 'from-orange-500 to-orange-600' },
    { rank: '551-700', name: 'Voleybol Topu', value: '150 Adet', count: 150, icon: 'ri-ball-pen-line', color: 'from-blue-500 to-blue-600' },
    { rank: '701-850', name: 'Satranç Takımı', value: '150 Adet', count: 150, icon: 'ri-chess-line', color: 'from-amber-700 to-amber-800' },
    { rank: '851-1000', name: 'Dünya Klasikleri Kitap Seti', value: '150 Adet', count: 150, icon: 'ri-book-line', color: 'from-indigo-600 to-indigo-700' }
  ];

  const topPrizes = prizes.slice(0, 6);
  const otherPrizes = prizes.slice(6);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-slate-800 to-slate-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Muhteşem <span className="text-yellow-400">Ödüller</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Toplam <span className="text-yellow-400 font-bold">5 Milyon TL</span> değerinde 
            <span className="text-yellow-400 font-bold"> 1.000 kişiye</span> verilecek ödüller
          </p>
          <div className="flex flex-wrap justify-center gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-yellow-400">5M TL</div>
              <div className="text-sm text-gray-300">Toplam Ödül</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-yellow-400">1.000</div>
              <div className="text-sm text-gray-300">Kazanan Kişi</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-yellow-400">31</div>
              <div className="text-sm text-gray-300">Farklı Ödül</div>
            </div>
          </div>
        </div>
      </section>

      {/* Top Prizes */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
              En Büyük Ödüller
            </h2>
            <p className="text-xl text-gray-600">
              İlk 6 sıradaki muhteşem ödüller
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {topPrizes.map((prize, index) => (
              <Card key={index} className="text-center hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="relative mb-6">
                  <div className={`w-20 h-20 bg-gradient-to-r ${prize.color} rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg`}>
                    <i className={`${prize.icon} text-3xl text-white`}></i>
                  </div>
                  <div className="absolute -top-2 -right-2 bg-yellow-400 text-gray-900 text-xs font-bold px-2 py-1 rounded-full">
                    #{prize.rank}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-3">
                  {prize.name}
                </h3>
                <p className="text-gray-600 mb-4">
                  {prize.value}
                </p>
                <div className="bg-gray-100 rounded-lg px-4 py-2 inline-block">
                  <span className="text-sm font-semibold text-gray-700">
                    {prize.count} Adet
                  </span>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* All Prizes Table */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
              Tüm Ödüller Listesi
            </h2>
            <p className="text-xl text-gray-600">
              1.000 kişiye verilecek tüm ödüllerin detaylı listesi
            </p>
          </div>

          <Card className="overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-slate-800 text-white">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-semibold">Sıra</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">Ödül</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">Değer/Açıklama</th>
                    <th className="px-6 py-4 text-center text-sm font-semibold">Adet</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {prizes.map((prize, index) => (
                    <tr key={index} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-3">
                          <div className={`w-8 h-8 bg-gradient-to-r ${prize.color} rounded-lg flex items-center justify-center`}>
                            <i className={`${prize.icon} text-white text-sm`}></i>
                          </div>
                          <span className="font-semibold text-slate-800">
                            {prize.rank}
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="font-medium text-slate-800">
                          {prize.name}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-gray-600">
                        {prize.value}
                      </td>
                      <td className="px-6 py-4 text-center">
                        <span className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-semibold">
                          {prize.count}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>

          <div className="mt-12 text-center">
            <Card className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900">
              <h3 className="text-2xl font-bold mb-4">
                Toplam Ödül Değeri
              </h3>
              <div className="text-4xl md:text-5xl font-bold mb-2">
                5.000.000 TL
              </div>
              <p className="text-lg">
                1.000 şanslı katılımcıya dağıtılacak
              </p>
            </Card>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
